import React from "react";
import IconGlyph from "@/bit/components/components.icon-glyph";

const SmartWifiFake = () => {
  return (
    <>
      <section className="smart-wifi-device-fake">
        <div className="skeleton smart-wifi-device-fake--title" />
        <div className="smart-wifi-device-fake--boxes">
          <div className="smart-wifi-device-fake--boxes--input">
            <div className="skeleton smart-wifi-device-fake--boxes--input--text" />
            <IconGlyph id="cheuron-down-m" height="16px" color="movistarBlue" />
          </div>
          <div className="smart-wifi-device-fake--boxes--input">
            <div className="skeleton smart-wifi-device-fake--boxes--input--text" />
            <IconGlyph id="ojo-abierto" height="22px" color="grey4" />
          </div>
        </div>
      </section>
      <style jsx>{`
        .smart-wifi-device-fake {
          display: flex;
          flex-direction: column;
          padding: 1rem;
          border: 1px solid #ddd;
          border-radius: 8px;
          gap: 1rem;
          &--title {
            height: 18px;
            width: 150px;
          }
          &--boxes {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            gap: 1rem;
            &--input {
              display: flex;
              flex-direction: row;
              padding: 1.5rem;
              justify-content: space-between;
              align-items: center;
              border: 1px solid #ddd;
              border-radius: 4px;
              &--text {
                height: 16px;
                width: 150px;
              }
            }
          }
        }
        @media (min-width: 768px) {
          .smart-wifi-device-fake--boxes {
            flex-direction: row;
            justify-content: space-between;
            &--input {
              width: 45%;
            }
          }
        }
      `}</style>
    </>
  );
};

export default SmartWifiFake;
